// features/config-sistema/api/configSistema.api.js
// Capa de API para configuración del sistema (colores, SMTP, etc.)

import { api } from '../../../api/client';

export const smtpSystemConfigurationsApi = {
  /**
   * Obtiene la configuración activa del sistema (pública, sin token).
   * Esta llamada NO pasa por el cliente centralizado porque se ejecuta
   * antes del login (en SystemContext.jsx).
   * Aquí se expone para uso dentro de componentes autenticados.
   */
  // getActive: () =>
  //   api.get('/system-configuration/istrue'),

  /** Obtiene configuración SMTP */
  // getSmtp: () =>
  //   api.get('/system-configuration/configurationSmtp'),

  /** Lista todas las configuraciones */

  search: (search) => api.post('/system-configuration/smtp/search', search),

  getAll: (data = { page: 1, size: 10 }) => api.post('/system-configuration/smtp', data),

  /**
   * Crea una configuración
   * @param {object} data
   */
  create: (data) => api.post('/system-configuration/smtp', data),

  testSmtp: (data) => api.post('/system-configuration/smtp/test-connection', data),

  getActiveSmtp: () => api.get(`/system-configuration/smtp/active`),
  /**
   * Actualiza una configuración por id
   * @param {string|number} id
   * @param {object} data
   */
  update: (id, data) => api.put(`/system-configuration/smtp/${id}`, data),

  /**
   * Elimina una configuración por id
   * @param {string|number} id
   */
  remove: (id) => api.delete(`/system-configuration/smtp/${id}`),
};
